<template>
  <div>
    <vue-html2pdf
      :show-layout="true"
      :float-layout="false"
      :enable-download="true"
      :preview-modal="true"
      :filename="'invoices_pdf'"
      :pdf-quality="2"
      pdf-orientation="portrait"
      :paginate-elements-by-height="1100"
      ref="html2Pdf"
      pdf-format="a4"
      pdf-content-width="800px"
      class="black-text hidden"
    >
      <!--
      @progress="onProgress($event)"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
       -->

      <section slot="pdf-content">
        <!-- PDF Content Here -->
        <section class="pdf-item">
          <!-- Header START-->
          <div class="main-wrapper">
            <div class="statement-page">
              <div class="statement-top">
                <img class="statement-logo" src="img/TurkishRestaurantLogo.png"/>

                <div class="statement-header">
                  <h2>Your {{monthName(userDates[0])}} Statement</h2>
                  <p>For {{ formatDate(userDates[0]) }} to {{ formatDate(userDates[1]) }}</p>
                </div>
                <div class="statement-for">
                  <h3>{{ selectedRestaurant.user_property['Restaurant-Name'] }}</h3>
                  <h4> {{selectedRestaurant.user_property['Address']}}</h4>
                </div>
                <div class="statement-summary">
                  <div class="st-row head">
                    <div class="st-column head"><h2>Total payments to you</h2></div>
                    <div class="st-column head"><h2>${{(parseFloat(delivery_total.total) + parseFloat(pickup_total.total)).toFixed(2)}}</h2></div>
                  </div>
                  <div class="st-row">
                    <div class="st-column">
                      <h3>Paid directly to your bank account</h3>
                      <p>Includes <strong>${{(parseFloat(delivery_total.tax) + parseFloat(pickup_total.tax)).toFixed(2)}}</strong> in taxes you are responsible for paying to the proper taxing
                        authority</p>
                    </div>
                    <div class="st-column">${{(parseFloat(delivery_total.total) + parseFloat(pickup_total.total)).toFixed(2)}}</div>
                  </div>
                </div>
              </div>

              <div class="statement-mid mb-20">
                <div class="st-row">
                  <div class="st-column"><h2>Restaurant Sales for {{ itemData.data.length }} orders</h2></div>
                  <div class="st-column"><h2>${{ itemData.total.toFixed(2) }}</h2></div>
                </div>
                <div class="st-row">
                  <div class="st-column">Delivery Orders</div>
                  <div class="st-column">${{ delivery_total.total }}</div>
                </div>
                <div class="st-row">
                  <div class="st-column">Pickup Orders</div>
                  <div class="st-column">${{ pickup_total.total }}</div>
                </div>
                <div class="st-row">
                  <div class="st-column">Platform Fee</div>
                  <div class="st-column">${{(parseFloat(delivery_total.platform_fee) + parseFloat(pickup_total.platform_fee)).toFixed(2)}}</div>
                </div>
              </div>
              <div class="html2pdf__page-break"></div>
              <div class="statement-header mt-20">
                <h2>Your {{monthName(userDates[0])}} Deposits</h2>
              </div>
              <div class="trans-detail statement">
                <div class="trans-detail-head">
                  <div class="trans-top-row row-head">
                    <div class="trans-top-column">Deposit Date</div>
                    <div class="trans-top-column">Transferred To</div>
                  </div>
                  <div class="trans-top-row row-body">
                    <div class="trans-top-column">Period {{ formatDate(userDates[0]) }} to {{formatDate(userDates[1])}}</div>
                    <div class="trans-top-column">Account Ending in {{ stripeAccount.external_accounts.data[0].last4 }}</div>
                  </div>
                </div>
                <div class="trans-detail-body">
                  <div class="trans-body-head">
                    <div class="trans-body-row">
                      <div class="trans-body-column">
                        Order Type
                      </div>
                      <div class="trans-body-column">
                        Quantity
                      </div>
                      <div class="trans-body-column">
                        Subtotal
                      </div>
                      <div class="trans-body-column">
                        Sales Tax
                      </div>
                      <div class="trans-body-column">
                        Tip
                      </div>
                      <div class="trans-body-column">
                        Platform Fee
                      </div>
                      <div class="trans-body-column">
                        Revenue
                      </div>
                    </div>
                  </div>
                  <div class="trans-body">
                    <div class="trans-body-row">
                      <div class="trans-body-column">
                        {{ delivery_total.type }}
                      </div>
                      <div class="trans-body-column">
                        {{ delivery_total.quantity }}
                      </div>
                      <div class="trans-body-column">
                        ${{ delivery_total.subtotal }}
                      </div>
                      <div class="trans-body-column">
                        ${{ delivery_total.tax }}
                      </div>
                      <div class="trans-body-column">
                        ${{ delivery_total.tipPrice }}
                      </div>
                      <div class="trans-body-column">
                        -${{ delivery_total.platform_fee }}
                      </div>
                      <div class="trans-body-column">
                        ${{delivery_total.total}}
                      </div>
                    </div>
                    <div class="trans-body-row">
                      <div class="trans-body-column">
                        {{ pickup_total.type }}
                      </div>
                      <div class="trans-body-column">
                        {{ pickup_total.quantity }}
                      </div>
                      <div class="trans-body-column">
                        ${{ pickup_total.subtotal }}
                      </div>
                      <div class="trans-body-column">
                        ${{ pickup_total.tax }}
                      </div>
                      <div class="trans-body-column">
                        ${{ pickup_total.tipPrice }}
                      </div>
                      <div class="trans-body-column">
                        -${{ pickup_total.platform_fee }}
                      </div>
                      <div class="trans-body-column">
                        ${{pickup_total.total}}
                      </div>
                    </div>
                    <div class="trans-body-row summary">
                      <div class="trans-body-column">

                      </div>
                      <div class="trans-body-column">
                        {{ delivery_total.quantity + pickup_total.quantity }}
                      </div>
                      <div class="trans-body-column">
                        ${{(parseFloat(delivery_total.subtotal) + parseFloat(pickup_total.subtotal)).toFixed(2)}}
                      </div>
                      <div class="trans-body-column">
                        ${{(parseFloat(delivery_total.tax) + parseFloat(pickup_total.tax)).toFixed(2)}}
                      </div>
                      <div class="trans-body-column">
                        ${{(parseFloat(delivery_total.tipPrice) + parseFloat(pickup_total.tipPrice)).toFixed(2)}}
                      </div>
                      <div class="trans-body-column">
                        -${{(parseFloat(delivery_total.platform_fee) + parseFloat(pickup_total.platform_fee)).toFixed(2)}}
                      </div>
                      <div class="trans-body-column">
                        ${{(parseFloat(delivery_total.total) + parseFloat(pickup_total.total)).toFixed(2)}}
                      </div>

                    </div>
                  </div>
                </div>
              </div>


            </div>
            <div class="statement-page">

              <div class="statement-header full-width">
                <h2>Your Sales TAX</h2>
                <p>Turkish Restaurant collected <strong>${{(parseFloat(delivery_total.tax) + parseFloat(pickup_total.tax)).toFixed(2)}}</strong> in taxes for the
                  orders outlined above and sent directly to you. As part of your normal periodic
                  tax return filing, it is your responsibility to pay <strong>${{(parseFloat(delivery_total.tax) + parseFloat(pickup_total.tax)).toFixed(2)}}</strong> to the
                  proper taxing authority for such orders. Upon receipt of the <strong>${{(parseFloat(delivery_total.tax) + parseFloat(pickup_total.tax)).toFixed(2)}}</strong>
                  in taxes shown in this statement, you hereby attest and confirm that you are properly registered with and
                  will report and remit such amounts to the proper
                  taxing authority on the appropriate periodic tax return. If these amounts are not reported and remitted by
                  you for any reson,
                  you will notify Turkish Restaurant thereof.</p>
                <h5>Under federal law, tips paid by customers are the property of employees, and employers are prohibited from
                  taking an employee's tips for any reson.</h5>
              </div>

            </div>
          </div>
        </section>
        <div class="html2pdf__page-break"></div>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import Logo from '../Logo'
import moment from 'moment'

export default {
  props: {
    item: {
      type: Object
    },
    stripeAccount: {
      type: Object
    }
  },
  name: 'printPdfTemplate',
  data () {
    return {
      tipPrice: 0
    }
  },
  components: {
    VueHtml2pdf,
    Logo
  },
  mounted () {
    this.generateReport()
  },
  computed: {

    delivery_total () {
      const type = 'Delivery'
      let quantity = 0
      let subtotal = 0
      let tax = 0
      let total = 0
      let platform_fee = 0
      let tipPrice = 0

      this.itemData.data.map(order => {
        if (order.delivery_type === 1 && order.transfer) {
          quantity++
          subtotal += order.product_price
          total += (order.transfer.amount / 100)
          tax += parseFloat(order.tax)
          tipPrice += order.tip_price
          platform_fee += (order.total_amount - (order.transfer.amount / 100))
        }
      })


      return {
        type,
        quantity,
        total: total.toFixed(2),
        subtotal: subtotal.toFixed(2),
        tax: parseFloat(tax).toFixed(2),
        platform_fee: platform_fee.toFixed(2),
        tipPrice: parseFloat(tipPrice).toFixed(2)
      }
    },
    pickup_total () {
      const type = 'Pick up'
      let quantity = 0
      let subtotal = 0
      let total = 0
      let tax = 0
      let platform_fee = 0
      let tipPrice = 0


      this.itemData.data.map(order => {
        if (order.delivery_type === 2 && order.transfer) {
          quantity++
          subtotal += order.product_price
          total += (order.transfer.amount / 100)
          tax += parseFloat(order.tax)
          tipPrice += order.tip_price
          platform_fee += (order.total_amount - (order.transfer.amount / 100))
        }
      })


      return {
        type,
        quantity,
        total: total.toFixed(2),
        subtotal: subtotal.toFixed(2),
        tax: parseFloat(tax).toFixed(2),
        platform_fee: platform_fee.toFixed(2),
        tipPrice: parseFloat(tipPrice).toFixed(2)
      }
    },
    userDates () {
      return this.item[Object.keys(this.item)[0]].dates
    },
    itemData () {
      return this.item[Object.keys(this.item)[0]]
    },
    selectedRestaurant () {
      let obj = this.$store.state.api.selectedRestaurant
      if (!obj) {
        try {
          obj = JSON.parse(localStorage.getItem('selectedRestaurant'))
        } catch (e) {
          obj = null
        }
      }
      return obj
    }
  },
  methods: {
    formatDate (time) {
      return moment(time).format('MM/DD/YYYY')
    },
    monthName (time) {
      return moment(time).format('MMMM')
    },
    formatDate2 (time) {
      return moment(time).format('MM/DD')
    },
    formatPrice (value) {
      const val = (value / 1).toFixed(2)
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    calculatePrice (priceitem) {
      const item = JSON.parse(JSON.stringify(priceitem))
      if (item.size) {
        item.price = item.size.selected_value.price
      }
      if (item.modifier.length > 0) {
        item.modifier.forEach(function (key) {

          if (typeof key.modifier.selected_value !== 'undefined') {
            if (Array.isArray(key.modifier.selected_value)) {
              key.modifier.selected_value.forEach(function (mod_val) {
                item.price = Number(item.price) + Number(mod_val.price)
              })
            } else {
              item.price = Number(item.price) + Number(key.modifier.selected_value.price)
            }

          }
        })
      }
      return item.price * item.quantity
    },
    generateReport () {
      this.$refs.html2Pdf.generatePdf()
      setTimeout(() => {
        this.close()
      }, 500)
    },
    close () {
      // destroy the vue listeners, etc
      this.$destroy()

      // remove the element from the DOM
    }
  }
}
</script>

<style lang="scss">
/* STATEMENT PAGE START*/
.statement-page {
  width:800px;
  height: auto;
  padding:40px;
  font-size:16px;

  h2, h3, h4, div, span {
    color: #333;
    font-size: 100%;
    line-height: 2.5;
  }
}
.statement-header, .statement-for, .statemet-summary {
  margin:25px 0;
}
.statement-header, .statement-for{
  display:inline-block;
  width:calc(50% - 4px);
}
.statement-for {
  text-align: right;
}
.statement-summary {
  border:2px solid #000;
}
.st-row{
  display:flex;
  justify-content: space-between;
}
.st-row .head {
  background-color:#ccc;
  padding:10px 20px;
}
.st-column {
  padding:20px;
}
.st-column:first-child{
  width:75%;
}
.st-column:last-child{
  width:25%;
  text-align: right;
}
.statement-mid .st-row{
  border-bottom:1px solid #ccc;
}
.trans-detail.statement{
  padding:10px;
  margin-bottom:20px;
}
.trans-detail.statement .trans-body-column{
  padding:0;
}
.trans-detail.statement .trans-body-head{
  font-size:12px;
}
.trans-detail.statement .trans-top-row.row-body {
  padding-top:0;
  font-size:10px;
}
.statement-header.full-width{
  width:100%;
  display: block;
  font-size:14px;
  padding:10px;
}
.statement-header p {
  margin-bottom:20px;
}
</style>
